export enum AuthenticationMethod {
  WEZEL_KRAJOWY = 'WEZEL_KRAJOWY',
  QUALIFIED_SIGNATURE = 'QUALIFIED_SIGNATURE',
}

export const AUTHENTICATION_METHOD_LABELS: Record<AuthenticationMethod, string> = {
  [AuthenticationMethod.WEZEL_KRAJOWY]: 'Węzeł krajowy',
  [AuthenticationMethod.QUALIFIED_SIGNATURE]: 'Podpis kwalifikowany',
};

export function getAuthenticationMethodDropdownItems() {
  return Object.entries(AUTHENTICATION_METHOD_LABELS).map(([key, label]) => ({
    label,
    value: key,
  }));
}
